import Button from "components/foundation/Button";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { UserProfileInput } from "../UserProfileInput/UserProfileInput";
import UserProfilePhoneInput from "../UserProfileInput/UserProfilePhoneInput";
import UserProfileSignInput from "../UserProfileInput/UserProfileSignInput";
import {
  UserProfileFormBoard,
  UserProfileDescription,
  UserProfileFormFooter,
} from "./styles";
import { ProfileFormData } from "./UserProfileFormCard";
import { UserDetailResponse } from "apis/data-contracts";
import REGEX from "config/regex";

export interface UserProfileFormProps {
  setIsWithDrawModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  defaultData: UserDetailResponse;
  currentPassword: string;
}

const UserProfileForm = ({
  setIsWithDrawModalOpen,
  defaultData,
  currentPassword,
}: UserProfileFormProps) => {
  const {
    control,
    formState: { errors, isValid },
    register,
    watch,
  } = useFormContext<ProfileFormData>();

  const password = watch("password");

  const [hasPhoneNumberError, setHasPhoneNumberError] = useState(false);

  return (
    <UserProfileFormBoard isShadow>
      <h1>회원 가입 정보</h1>
      <UserProfileInput value={defaultData.company} label="회사" disabled />
      <UserProfileInput value={defaultData.department} label="부서" disabled />
      <UserProfileInput value={defaultData.position} label="직급" disabled />
      <UserProfileInput value={defaultData.name} label="이름" disabled />
      <UserProfileSignInput label="서명이미지" src={defaultData.signImageUrl} />
      <UserProfileInput value={defaultData.email} label="이메일" disabled />
      <Controller
        name="phone"
        control={control}
        render={({ field }) => (
          <UserProfilePhoneInput
            label="연락처"
            value={field.value}
            onPhoneChange={(value) => {
              field.onChange(value);
            }}
            onHasError={(value) => setHasPhoneNumberError(value)}
          />
        )}
      ></Controller>

      <UserProfileInput
        type="password"
        placeholder="비밀번호를 지정해 주세요"
        label="변경할 비밀번호"
        {...register("password", {
          pattern: {
            value: REGEX.PASSWORD,
            message: "영문, 숫자, 특수문자를 포함하여 8자 이상 20자 이내",
          },
          validate: (value) =>
            value !== currentPassword ||
            "이전에 사용한 비밀번호는 사용할 수 없습니다.",
        })}
        errorMessage={errors.password?.message}
      >
        {!errors.password ? (
          <UserProfileDescription>
            영문, 숫자, 특수문자를 포함하여 8자이상 20자이내
          </UserProfileDescription>
        ) : (
          <></>
        )}
      </UserProfileInput>

      <UserProfileInput
        type="password"
        placeholder="비밀번호를 다시 한 번 입력해 주세요"
        label="비밀번호 확인"
        {...register("passwordConfirm", {
          validate: (value) =>
            value === password || "비밀번호가 일치하지 않습니다.",
        })}
        errorMessage={errors.passwordConfirm?.message}
      />
      <UserProfileFormFooter>
        <Button
          variant="tertiary"
          size="large"
          onClick={() => {
            setIsWithDrawModalOpen(true);
          }}
        >
          회원탈퇴
        </Button>
        <Button
          size="large"
          type="submit"
          disabled={hasPhoneNumberError || !isValid}
        >
          저장
        </Button>
      </UserProfileFormFooter>
    </UserProfileFormBoard>
  );
};

export default UserProfileForm;
